export const CHANGE_TV_SCREEN = 'CHANGE_TV_SCREEN' as const;

export const GET_TV_DATA_REQUEST = 'GET_TV_DATA_REQUEST' as const;
export const GET_TV_DATA_SUCCESS = 'GET_TV_DATA_SUCCESS' as const;
export const GET_TV_DATA_ERROR = 'GET_TV_DATA_ERROR' as const;

export const RESET_TV_SCREEN = 'RESET_TV_SCREEN' as const;
